<template>
  <el-card>
    <div slot="header" class="toolbar">
      <span>图片信息</span>
      <div>
        <el-button
          v-if="$hasPermission('mall:image-resource:upload')"
          type="primary"
          size="mini"
          @click="openUploadDialog"
        >
          上传图片
        </el-button>
      </div>
    </div>

    <div class="search-bar search-wrap">
      <el-select v-model="query.categoryCode" clearable placeholder="图片类别" style="width: 220px">
        <el-option
          v-for="item in categoryOptions"
          :key="item.code"
          :label="item.name"
          :value="item.code"
        />
      </el-select>
      <el-input
        v-model.trim="query.keyword"
        placeholder="请输入文件名或访问地址"
        clearable
        style="width: 280px"
        @keyup.enter.native="handleSearch"
      />
      <el-button type="primary" @click="handleSearch">查询</el-button>
      <el-button @click="reset">重置</el-button>
    </div>

    <el-table :data="list" border style="width: 100%">
      <el-table-column prop="id" label="编号" width="90" />
      <el-table-column label="预览图" width="110">
        <template slot-scope="{ row }">
          <el-image
            :src="resolveFileUrl(row.accessUrl)"
            :preview-src-list="row.accessUrl ? [resolveFileUrl(row.accessUrl)] : []"
            fit="cover"
            class="table-image"
          >
            <div slot="error" class="table-image-error">无图</div>
          </el-image>
        </template>
      </el-table-column>
      <el-table-column prop="categoryName" label="图片类别" width="140" />
      <el-table-column prop="fileName" label="文件名" min-width="180" show-overflow-tooltip />
      <el-table-column prop="accessUrl" label="访问地址" min-width="260" show-overflow-tooltip />
      <el-table-column prop="storagePath" label="存储地址" min-width="320" show-overflow-tooltip />
      <el-table-column prop="fileSize" label="文件大小" width="120">
        <template slot-scope="{ row }">
          {{ formatFileSize(row.fileSize) }}
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="上传时间" width="170" />
    </el-table>

    <div class="pagination-bar">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="query.page"
        :page-size="query.limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />
    </div>

    <el-dialog title="上传图片" :visible.sync="dialogVisible" width="620px" :close-on-click-modal="false">
      <el-form label-width="90px">
        <el-form-item label="图片类别">
          <el-select v-model="uploadForm.categoryCode" placeholder="请选择图片类别" style="width: 100%">
            <el-option
              v-for="item in uploadCategoryOptions"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="图片文件">
          <el-upload
            ref="uploadRef"
            action=""
            :auto-upload="false"
            :file-list="fileList"
            :multiple="true"
            accept="image/*,.heic,.heif"
            list-type="picture"
            :on-change="handleFileChange"
            :on-remove="handleFileRemove"
          >
            <el-button size="mini" type="primary">选择图片</el-button>
            <div slot="tip" class="el-upload__tip">
              支持 JPG、PNG、WEBP、GIF、BMP、HEIC、HEIF，可一次选择多张；HEIC/HEIF 会原样上传，不参与压缩。
            </div>
          </el-upload>
          <div v-if="fileList.length" class="upload-count">已选择 {{ fileList.length }} 张</div>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="closeUploadDialog">取消</el-button>
        <el-button
          v-if="$hasPermission('mall:image-resource:upload')"
          type="primary"
          :loading="uploading"
          @click="startUpload"
        >
          开始上传
        </el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import http from '../../utils/http'
import { resolveFileUrl } from '../../utils/file'

function defaultQuery () {
  return {
    page: 1,
    limit: 10,
    categoryCode: '',
    keyword: ''
  }
}

export default {
  computed: {
    uploadCategoryOptions () {
      return this.categoryOptions.filter(item => item.code !== 'after-sale')
    }
  },
  data () {
    return {
      categoryOptions: [],
      query: defaultQuery(),
      total: 0,
      list: [],
      dialogVisible: false,
      uploadForm: {
        categoryCode: ''
      },
      fileList: [],
      uploading: false
    }
  },
  created () {
    this.loadCategories()
    this.load()
  },
  methods: {
    resolveFileUrl,
    async loadCategories () {
      const { data } = await http.get('/mall/image-resource/category-options')
      this.categoryOptions = data.data || []
    },
    async load () {
      const { data } = await http.get('/mall/image-resource/list', { params: this.query })
      const pageData = data.data || {}
      this.list = pageData.list || []
      this.total = Number(pageData.total || 0)
    },
    handleSearch () {
      this.query.page = 1
      this.load()
    },
    handlePageChange (page) {
      this.query.page = page
      this.load()
    },
    handleSizeChange (limit) {
      this.query.limit = limit
      this.query.page = 1
      this.load()
    },
    reset () {
      this.query = defaultQuery()
      this.load()
    },
    openUploadDialog () {
      const queryCategoryCanUpload = this.uploadCategoryOptions.some(item => item.code === this.query.categoryCode)
      this.dialogVisible = true
      this.uploadForm = {
        categoryCode: queryCategoryCanUpload
          ? this.query.categoryCode
          : (this.uploadCategoryOptions.length ? this.uploadCategoryOptions[0].code : '')
      }
      this.fileList = []
    },
    closeUploadDialog () {
      this.dialogVisible = false
      this.fileList = []
    },
    handleFileChange (file, fileList) {
      this.fileList = fileList
    },
    handleFileRemove (file, fileList) {
      this.fileList = fileList
    },
    async startUpload () {
      if (!this.uploadForm.categoryCode) {
        this.$message.warning('请先选择图片类别')
        return
      }
      if (!this.fileList.length) {
        this.$message.warning('请先选择图片文件')
        return
      }
      this.uploading = true
      try {
        const formData = new FormData()
        formData.append('categoryCode', this.uploadForm.categoryCode)
        this.fileList.forEach(item => {
          formData.append('files', item.raw)
        })
        const { data } = await http.post('/mall/image-resource/upload-batch', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
          timeout: 300000
        })
        if (data.code === 0) {
          const uploaded = Array.isArray(data.data) ? data.data.length : this.fileList.length
          this.$message.success(`成功上传 ${uploaded} 张图片`)
          this.closeUploadDialog()
          this.query.page = 1
          this.query.categoryCode = this.uploadForm.categoryCode
          this.load()
        }
      } finally {
        this.uploading = false
      }
    },
    formatFileSize (size) {
      const value = Number(size || 0)
      if (value < 1024) {
        return `${value} B`
      }
      if (value < 1024 * 1024) {
        return `${(value / 1024).toFixed(2)} KB`
      }
      return `${(value / 1024 / 1024).toFixed(2)} MB`
    }
  }
}
</script>

<style scoped>
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.search-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.search-wrap {
  flex-wrap: wrap;
}

.table-image {
  width: 64px;
  height: 64px;
  border-radius: 6px;
  border: 1px solid #ebeef5;
  cursor: pointer;
}

.table-image-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
  background: #f5f7fa;
}

.upload-count {
  margin-top: 8px;
  color: #606266;
  font-size: 12px;
}

.pagination-bar {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
</style>
